module.exports = __webpack_public_path__ + "static/media/07_Maf_NuestroEquipo_LourdesGaribay.271a0f05-01.0bc1573b.png";